import { LotQuery } from 'components/pages/LotBasePage/types/lotQuery'
import React from 'react'
import HeroSection from 'components/HeroSection'
import CtaSection from 'components/pages/LotPage/CtaSection'
import Locations from 'components/pages/LotPage/Locations'
import LotDescription from 'components/pages/LotPage/LotDescription'
import Notice from 'components/pages/LotBasePage/Notice'
import AppAds from 'components/AppAds'
import LotSection from 'components/pages/LotPage/LotSection'
import LotReferralSection from 'components/LotReferralSection'
import FallbackImage from 'images/truck-crowd.jpg'
import { useRouter } from 'next/router'
import LinksSection from 'components/HeroSection/LinksSection'

type Props = {
  lot: NonNullable<LotQuery['lot']>
  globalConfig: NonNullable<LotQuery['globalConfig']>
}

const LotPage = ({ lot, globalConfig }: Props) => {
  const router = useRouter()
  const heroLinks = {
    twitter: lot.twitter,
    facebook: lot.facebook,
    instagram: lot.instagram,
    tiktok: lot.tiktok,
    website: lot.website,
    info: '#info'
  }
  const hideMarketing =
    router.asPath.includes('boeing') || router.asPath.includes('homedepot')
  return (
    <div className="w-full bg-white">
      <HeroSection
        content={
          <LotSection
            address={lot.fullAddress}
            creditForSubscriptions={lot.creditForSubscriptions}
            heroLinks={heroLinks}
            name={lot.name}
            subscriptionLotId={lot.id}
          />
        }
        imageSrc={lot.image?.present ? lot.image?.original! : FallbackImage}
        links={<LinksSection socialLinks={heroLinks} />}
        size="medium"
      />
      {lot.notice.present && (
        <div className="max-w-7xl mx-auto sm:pt-2 md:px-8 sm:px-4">
          <Notice notice={lot.notice} />
        </div>
      )}
      <Locations
        locationSchedule={lot.locationSchedule}
        schedulePath={lot.schedulePath}
      />
      <LotDescription
        address={lot.fullAddress}
        description={lot.description}
        email={lot.email}
        lotName={lot.name}
        marker={{
          lat: lot.latitude,
          lng: lot.longitude
        }}
        organizationName={lot.organization.name}
        phone={lot.phone}
      />
      {!hideMarketing && <CtaSection />}
      <AppAds />
      <LotReferralSection
        lotEnabled={lot.referralEnabled}
        lotId={lot.id}
        lotName={lot.name}
        lotUrl={lot.lotUrl}
        referralBonus={globalConfig.bonusForReferral}
      />
    </div>
  )
}

export default LotPage
